import { render, staticRenderFns } from "./PaymentMethodChooseSchool.vue?vue&type=template&id=1c475b24&"
import script from "./PaymentMethodChooseSchool.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodChooseSchool.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodChooseSchool.vue?vue&type=style&index=0&id=1c475b24&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports